import { useMutation } from "@tanstack/react-query";
import React from "react";
import { toast } from "sonner";

import * as fbs from "@/api/fbs";
import { Button } from "@/components/ui/button";
import { SGTIN_REMOVE_WARNING } from "@/lib/fbs";
import { Dialog } from "@/lib/scan-ui/overlays";
import { apiErrorText } from "@/lib/scan-ui/screen";

/** «Отправить без кода» у штуки, чей КИЗ WB забраковал, — с подтверждением:
 *  КИЗ убирается из задания WB (`DELETE …/meta?key=sgtin`).
 *
 *  Только явное действие человека (решение владельца: автоудалений нет).
 *  Показывается лишь на ошибке КИЗ; прочие отказы (поставка уже передана,
 *  статус сменился) бэкенд возвращает 409 с текстом — он уходит в тост. */
export function RemoveSgtinButton({
  pickId,
  what,
  disabled,
  onRemoved,
}: {
  pickId: string;
  /** Как штуку назвать в вопросе: наклейка / артикул и задание. */
  what: string;
  disabled?: boolean;
  onRemoved: (row: fbs.IssueRow) => void;
}): React.ReactElement {
  const [asking, setAsking] = React.useState(false);
  const mut = useMutation({
    mutationFn: () => fbs.removeSgtin(pickId),
    onSuccess: (row) => {
      setAsking(false);
      toast.success("КИЗ убран из задания — штука уйдёт без кода");
      onRemoved(row);
    },
    onError: (e) => {
      setAsking(false);
      toast.error(apiErrorText(e, "Отправить без кода не удалось"));
    },
  });

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        className="text-rose-700"
        onClick={() => setAsking(true)}
        disabled={disabled || mut.isPending}
      >
        Отправить без кода
      </Button>
      {asking && (
        <Dialog
          title="Отправить без кода?"
          body={
            <>
              <b>{what}</b>. {SGTIN_REMOVE_WARNING}
            </>
          }
          confirmLabel="Отправить без кода"
          danger
          confirmBusy={mut.isPending}
          onConfirm={() => mut.mutate()}
          onCancel={() => setAsking(false)}
        />
      )}
    </>
  );
}
